import { Outlet } from "react-router-dom";
import { getAuthToken } from "./authHelpers";

const ProtectedRoute = () => {
  return (
    <>
      {getAuthToken() ? (
        <Outlet />
      ) : (
        (window.location.href = "/login")
      )}
    </>
  );
};

export default ProtectedRoute;
